import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Languages, Check } from "lucide-react";
import { useLang } from "@/context/LangContext";

const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
];

export default function LangToggle({ variant = "ghost", size = "icon" }) {
  const { lang, setLang } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid="lang-toggle" variant={variant} size={size} className="gap-1.5">
          <Languages className="w-4 h-4" />
          <span className="text-xs uppercase font-semibold">{lang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className="cursor-pointer flex items-center justify-between gap-6"
          >
            {l.label} {lang === l.code && <Check className="w-3.5 h-3.5 text-[hsl(var(--primary))]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
